<template>
  <div class="script-item" :class="{'hide-add-button': props.hideNewButton}">
    <div class="script-drag">
      <i class="pi pi-ellipsis-v"></i>
      <i class="pi pi-ellipsis-v"></i>
    </div>

    <div class="script">
      <div class="script-title">
        <template v-if="canEditTitle">
          <div class="p-inputgroup">
            <InputText v-model="script.title" autofocus @keydown.enter="finishEditTitle" :error="titleError" :maxLength="255" />
            <Button icon="pi pi-check" @click="finishEditTitle" :disabled="titleError.length"/>
          </div>
        </template>
        <template v-else>
          {{ props.index + 1 }}. {{ props.script.title }}
          <Button icon="pi pi-pencil" class="p-button-outlined script-title-button" @click="showTooltipMenu"/>
        </template>
      </div>
      <TieredMenu ref="tooltipMenu" :model="tooltipMenuItems" :popup="true" />
      <FormField title="Creator needs to say:" placeholder="Enter what Creator need to say..." class="p-fluid" iconRight="pi pi-pencil" componentType="textarea" rows="3" v-model="script.need_to_say" :maxLength="10000" />
      <FormField title="Creator needs to show:" placeholder="Enter what Creator need to show..." class="p-mb-0 p-fluid" iconRight="pi pi-pencil" componentType="textarea" rows="3" v-model="script.need_to_show" :maxLength="10000" />
    </div>
  </div>
</template>

<script setup>
import FormField from '../../FormField';
import {computed, ref, toRef} from "vue";
import {useVModel} from "@vueuse/core";

const emit = defineEmits(['add', 'delete', 'duplicate', 'update', 'update:script']);
const props = defineProps({
  script: {type: Object, required: true},
  index: {type: Number, required: true},
  hideNewButton: {type: Boolean}
});

const script = useVModel(props, 'script', emit, {deep: true});

const canEditTitle = ref(!script.value.title?.length);

const titleError = computed(() => !script.value.title ? 'The title is required.' : '')

const finishEditTitle = () => canEditTitle.value = false;

const tooltipMenu = ref();
const tooltipMenuItems = [
  {
    label: 'Edit title',
    icon: 'pi pi-fw pi-pencil',
    command: () => canEditTitle.value = true
  },
  {
    label: 'Duplicate',
    icon: 'pi pi-fw pi-copy',
    command: () => emit('duplicate', props.script, props.index)
  },
  {
    label: 'Delete',
    icon: 'pi pi-fw pi-trash',
    command: () => emit('delete', props.index)
  }
];

const showTooltipMenu = (event) => tooltipMenu.value.toggle(event)
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.script-item {
  position: relative;
  margin-left: toRem(-24);
  padding-left: toRem(24);

  .script-drag {
    opacity: 0;
    visibility: hidden;
  }

  &:hover {
    .script-drag {
      opacity: 1;
      visibility: visible;
    }
  }
}

.script {
  position: relative;
  padding: toRem(16);
  background: $gray;
  border-radius: 12px;
}

.script-drag {
  position: absolute;
  top: toRem(14);
  left: 0;
  cursor: pointer;
  overflow: hidden;
  width: 20px;
  color: $textThirdColor;
  transition: opacity 0.3s, visibility 0.3s;
  display: flex;

  .pi {
    width: 6px;

    &:first-child {
      margin-left: -6.5px;
    }
  }
}

.script-title {
  display: flex;
  margin-bottom: toRem(24);
  font-size: 18px;
  font-weight: bold;
  align-items: center;

  ::v-deep(.p-button.script-title-button) {
    padding: toRem(5);
    width: 20px;
    height: 20px;
    margin-left: toRem(8);

    .pi {
      font-size: 9px !important;
    }
  }

}

.duration-list {
  display: flex;
  justify-content: space-between;
  margin-top: toRem(2);
}

.duration {
  flex: 1;
  padding: toRem(8) 0;
  background: $bgBlocks;
  border-radius: $borderRadius;
  text-align: center;
  cursor: pointer;
  border: 1px solid transparent;
  font-weight: 500;
  font-size: 1rem;

  & + & {
    margin-left: toRem(8);
  }

  &.selected {
    border-color: #0F8BFD;
    color: $primaryColor;
  }
}

::v-deep(.p-inputtext) {
  padding-top: toRem(10);
  padding-left: toRem(8);
  padding-bottom: toRem(10);
  background: $bgBlocks;
  font-size: toRem(14);
}
</style>
